import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, MenuItem, Alert } from "@mui/material";
import { SectionProps, PROFESSION_KEYS, WUG_PROFESSIONS, ASSOCIATION_KEYS, LEGAL_BASIS_KEYS } from "./profileShared";

/** Erkenning & kwalificaties (vetting): beroep + de bijbehorende verplichte
 *  nummers. Verplichtingen spiegelen speakhere-api/src/util/credentials.ts. */
export default function CredentialsSection({ profile, onChange }: SectionProps) {
  const { t } = useTranslation();
  const setField = (key: string, v: string) => onChange({ ...profile, [key]: v });
  return (
    <Stack spacing={2.5}>
      <TextField select label={t("vetting.profession")} required value={profile.profession || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("profession", e.target.value)} sx={{ maxWidth: 340 }}>
        <MenuItem value="">{t("vetting.professionNone")}</MenuItem>
        {PROFESSION_KEYS.map((k) => <MenuItem key={k} value={k}>{t(`vetting.professions.${k}`)}</MenuItem>)}
      </TextField>

      {profile.profession === "psychotherapeut" && (
        <Alert severity="warning">{t("vetting.cmWarningProvider")}</Alert>
      )}

      {WUG_PROFESSIONS.includes(profile.profession || "") && (
        <Stack spacing={2}>
          <TextField label={t("vetting.visa")} required value={profile.visaNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("visaNumber", e.target.value)} sx={{ maxWidth: 340 }} />
          <TextField label={t("vetting.erkenning")} value={profile.erkenningNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("erkenningNumber", e.target.value)} sx={{ maxWidth: 340 }} />
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField label={t("vetting.riziv")} value={profile.rizivNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("rizivNumber", e.target.value)} sx={{ maxWidth: 260 }} />
            <TextField label={t("vetting.psychologenCommissie")} value={profile.psychologenCommissieNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("psychologenCommissieNumber", e.target.value)} sx={{ maxWidth: 260 }} />
          </Stack>
        </Stack>
      )}

      {profile.profession === "psychotherapeut" && (
        <Stack spacing={2}>
          <TextField select label={t("vetting.association")} required value={profile.professionalAssociation || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("professionalAssociation", e.target.value)} sx={{ maxWidth: 340 }}>
            <MenuItem value="">{t("vetting.professionNone")}</MenuItem>
            {ASSOCIATION_KEYS.map((k) => <MenuItem key={k} value={k}>{t(`vetting.associations.${k}`)}</MenuItem>)}
          </TextField>
          <TextField label={t("vetting.memberNumber")} value={profile.associationMemberNumber} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("associationMemberNumber", e.target.value)} sx={{ maxWidth: 340 }} />
          <TextField select label={t("vetting.legalBasis")} required value={profile.psychotherapyLegalBasis || ""} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setField("psychotherapyLegalBasis", e.target.value)} sx={{ maxWidth: 520 }}>
            <MenuItem value="">{t("vetting.professionNone")}</MenuItem>
            {LEGAL_BASIS_KEYS.map((k) => <MenuItem key={k} value={k}>{t(`vetting.legalBases.${k}`)}</MenuItem>)}
          </TextField>
        </Stack>
      )}
    </Stack>
  );
}
